import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Users, Building2, MessageSquare, Wallet, TrendingUp, Check, X, Sparkles, Trash2 } from "lucide-react";

export default function AdminDashboard() {
  const [tab, setTab] = useState("overview");
  const [stats, setStats] = useState({});
  const [users, setUsers] = useState([]);
  const [venues, setVenues] = useState([]);
  const [q, setQ] = useState("");
  const [role, setRole] = useState("");
  const [cityQ, setCityQ] = useState("");
  const [cities, setCities] = useState([]);
  const [newCity, setNewCity] = useState({ name: "", state: "" });
  const [pricing, setPricing] = useState({});

  const load = () => {
    api.get("/stats/overview").then(r=>setStats(r.data));
    api.get("/venues").then(r=>setVenues(r.data));
    api.get("/cities").then(r=>setCities(r.data));
    api.get("/config/pricing").then(r=>setPricing(r.data));
  };
  useEffect(()=>{ load(); }, []);
  useEffect(()=>{ api.get("/users", { params: { q, role, city: cityQ }}).then(r=>setUsers(r.data)); }, [q, role, cityQ]);

  const approve = async (id) => { await api.post(`/venues/${id}/approve`); toast.success("Approved"); load(); };
  const highlight = async (id) => { await api.post(`/venues/${id}/highlight`); toast.success("Toggled"); load(); };
  const delVenue = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/venues/${id}`); load(); };

  const addCity = async (e) => { e.preventDefault(); try { await api.post("/cities", { ...newCity, is_active: true }); toast.success("City added"); setNewCity({name:"",state:""}); load(); } catch { toast.error("Failed"); } };
  const savePricing = async () => { await api.put("/config/pricing", pricing); toast.success("Pricing saved"); };

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-10">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
        <div>
          <div className="text-[10px] uppercase tracking-widest-2 text-[color:var(--wine)]">Super Admin</div>
          <h1 className="font-display text-5xl">Control Center</h1>
          <p className="text-sm text-neutral-500 mt-1">Everything Shubh Muhurat runs on — venues, users, cities, pricing.</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-8">
        <Stat icon={Users} label="Users" value={stats.users}/>
        <Stat icon={Building2} label="Venues" value={stats.venues}/>
        <Stat icon={MessageSquare} label="Inquiries" value={stats.inquiries}/>
        <Stat icon={Wallet} label="Paid subs" value={stats.paid_subs}/>
        <Stat icon={TrendingUp} label="Revenue" value={`₹${Number(stats.revenue||0).toLocaleString("en-IN")}`}/>
        <Stat icon={Sparkles} label="Visitors" value={Number(stats.visitors||0).toLocaleString("en-IN")}/>
      </div>

      <div className="flex gap-1 border-b border-[color:var(--line)] mb-6 overflow-x-auto">
        {[["overview","Overview"],["venues","Venues"],["users","Users"],["cities","Cities"],["pricing","Pricing"],["reminders","Reminders"]].map(([k,l])=>(
          <button key={k} onClick={()=>setTab(k)} className={`px-4 py-2.5 text-sm ${tab===k ? "text-[color:var(--wine)] border-b-2 border-[color:var(--wine)]" : "text-neutral-500"}`} data-testid={`admin-tab-${k}`}>{l}</button>
        ))}
      </div>

      {tab==="overview" && (
        <div className="grid md:grid-cols-2 gap-6">
          <div className="card-luxury p-6">
            <div className="font-display text-2xl mb-4">Pending Approvals</div>
            <div className="space-y-2">
              {venues.filter(v=>!v.is_approved).slice(0,10).map(v=>(
                <div key={v.id} className="flex items-center justify-between border-b py-2 text-sm">
                  <span>{v.name} · {v.city}</span>
                  <button onClick={()=>approve(v.id)} className="text-xs px-3 py-1 rounded-full bg-green-50 text-green-700">Approve</button>
                </div>
              ))}
              {!venues.filter(v=>!v.is_approved).length && <div className="text-neutral-500 text-sm">Nothing pending.</div>}
            </div>
          </div>
          <div className="card-luxury p-6">
            <div className="font-display text-2xl mb-4">Recent Venues</div>
            <div className="space-y-2 text-sm">
              {venues.slice(0,10).map(v=><div key={v.id} className="flex justify-between border-b py-2"><span>{v.name}</span><span className="text-neutral-500">{v.city}</span></div>)}
            </div>
          </div>
        </div>
      )}

      {tab==="venues" && (
        <div className="card-luxury p-4 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs uppercase tracking-widest-2 text-neutral-500 text-left">
              <tr><th className="p-2">Name</th><th>City</th><th>Category</th><th>Approved</th><th>Premium</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {venues.map(v=>(
                <tr key={v.id} className="border-t">
                  <td className="p-2">{v.name}</td>
                  <td>{v.city}</td>
                  <td>{v.category}</td>
                  <td>{v.is_approved ? <Check className="w-4 h-4 text-green-600"/> : <X className="w-4 h-4 text-red-500"/>}</td>
                  <td>{v.highlighted ? "✨" : "—"}</td>
                  <td>
                    <div className="flex gap-2">
                      {!v.is_approved && <button onClick={()=>approve(v.id)} className="text-xs px-2 py-1 rounded bg-green-50 text-green-700">Approve</button>}
                      <button onClick={()=>highlight(v.id)} className="text-xs px-2 py-1 rounded bg-amber-50 text-amber-700">Toggle Premium</button>
                      <button onClick={()=>delVenue(v.id)} className="text-xs px-2 py-1 rounded bg-red-50 text-red-700"><Trash2 className="w-3 h-3"/></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab==="users" && (
        <div className="space-y-4">
          <div className="flex gap-3 flex-wrap">
            <input placeholder="Search name/email/phone" value={q} onChange={e=>setQ(e.target.value)} className="px-3 py-2 rounded-lg border flex-1 min-w-[240px]" data-testid="user-search-q"/>
            <select value={role} onChange={e=>setRole(e.target.value)} className="px-3 py-2 rounded-lg border">
              <option value="">All roles</option>
              <option value="customer">Customer</option>
              <option value="venue_owner">Venue Owner</option>
              <option value="staff">Staff</option>
              <option value="admin">Admin</option>
              <option value="major_admin">Major Admin</option>
              <option value="super_admin">Super Admin</option>
            </select>
            <input placeholder="City" value={cityQ} onChange={e=>setCityQ(e.target.value)} className="px-3 py-2 rounded-lg border"/>
          </div>
          <div className="card-luxury p-4 overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-xs uppercase tracking-widest-2 text-neutral-500 text-left"><tr><th className="p-2">Name</th><th>Email</th><th>Phone</th><th>City</th><th>Role</th><th>Target</th></tr></thead>
              <tbody>
                {users.map(u=>(<tr key={u.id} className="border-t"><td className="p-2">{u.name}</td><td>{u.email}</td><td>{u.phone||"—"}</td><td>{u.city||"—"}</td><td className="capitalize">{u.role?.replace("_"," ")}</td><td>{u.target||"—"}</td></tr>))}
                {!users.length && <tr><td colSpan={6} className="text-center py-6 text-neutral-500">No users</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {tab==="cities" && (
        <div className="grid md:grid-cols-3 gap-6">
          <form onSubmit={addCity} className="card-luxury p-6 space-y-3">
            <div className="font-display text-2xl">Add city</div>
            <input required placeholder="City" value={newCity.name} onChange={e=>setNewCity({...newCity, name:e.target.value})} className="w-full px-3 py-2.5 rounded-lg border"/>
            <input required placeholder="State" value={newCity.state} onChange={e=>setNewCity({...newCity, state:e.target.value})} className="w-full px-3 py-2.5 rounded-lg border"/>
            <button className="btn-wine w-full justify-center">Add</button>
          </form>
          <div className="md:col-span-2 card-luxury p-4 max-h-[520px] overflow-y-auto">
            <div className="text-sm font-medium mb-2">All cities ({cities.length})</div>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-1 text-sm">
              {cities.map(c=><div key={c.name} className="px-2 py-1 border-b">{c.name} <span className="text-xs text-neutral-500">{c.state}</span></div>)}
            </div>
          </div>
        </div>
      )}

      {tab==="reminders" && <RemindersPanel/>}

      {tab==="pricing" && (
        <div className="card-luxury p-6">
          <div className="font-display text-2xl mb-4">Subscription pricing (INR)</div>
          <div className="grid md:grid-cols-2 gap-4">
            {Object.entries(pricing?.categories || {}).map(([cat, prices])=>(
              <div key={cat} className="p-4 border rounded-xl">
                <div className="font-medium capitalize mb-2">{cat.replace("_"," ")}</div>
                <div className="flex gap-2">
                  {["6m","12m"].map(k=>(
                    <div key={k} className="flex-1">
                      <div className="text-xs text-neutral-500 mb-1">{k}</div>
                      <input type="number" value={prices[k]} onChange={e=>setPricing({...pricing, categories: {...pricing.categories, [cat]: {...prices, [k]: Number(e.target.value)}}})} className="w-full px-2 py-1.5 rounded border"/>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <button onClick={savePricing} className="btn-wine mt-4" data-testid="save-pricing">Save pricing</button>
        </div>
      )}
    </div>
  );
}

function Stat({icon: Icon, label, value}) {
  return (
    <div className="card-luxury p-5 relative overflow-hidden group">
      <div className="absolute -top-4 -right-4 w-20 h-20 rounded-full bg-[color:var(--wine)]/5 group-hover:bg-[color:var(--wine)]/10 transition-colors"/>
      <Icon className="w-5 h-5 text-[color:var(--wine)] mb-3 relative"/>
      <div className="text-3xl font-display relative">{value ?? "—"}</div>
      <div className="text-[10px] text-neutral-500 uppercase tracking-widest-2 mt-1 relative">{label}</div>
    </div>
  );
}

function RemindersPanel() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/renewal-reminders/test`, null, { params: { email }});
      toast.success(`Sent! Email ID: ${data.email_id?.slice(0,8)}…`);
    } catch (e) {
      toast.error("Failed to send. Check backend logs.");
    } finally { setBusy(false); }
  };
  return (
    <div className="grid md:grid-cols-2 gap-6">
      <div className="card-luxury p-6">
        <div className="font-display text-2xl mb-1">Renewal reminder emails</div>
        <p className="text-sm text-neutral-600 mb-4">Owners automatically receive branded reminder emails <strong>45</strong> and <strong>15</strong> days before their subscription expires. Runs daily at <strong>9:00 IST</strong> via a platform-scheduled cron.</p>
        <ul className="text-sm space-y-2 text-neutral-700">
          <li>· De-duplicated per owner + venue + milestone</li>
          <li>· From: <strong>Shubh Muhurat</strong> · Reply-to: hello@shubhmuhurat.in</li>
          <li>· Owners can renew directly from their dashboard</li>
        </ul>
      </div>
      <form onSubmit={send} className="card-luxury p-6 space-y-3" data-testid="reminder-test-form">
        <div className="font-display text-2xl">Send a preview</div>
        <p className="text-sm text-neutral-600">Enter any email to receive a sample renewal reminder as it will appear to a venue owner.</p>
        <input required type="email" placeholder="you@example.com" value={email} onChange={e=>setEmail(e.target.value)} className="w-full px-3 py-2.5 rounded-lg border" data-testid="reminder-test-email"/>
        <button disabled={busy} className="btn-wine w-full justify-center" data-testid="reminder-test-send">{busy ? "Sending…" : "Send preview email"}</button>
        <div className="text-[11px] text-neutral-500 mt-2">Tip: use <code>delivered@resend.dev</code> to safely test the send pipeline.</div>
      </form>
    </div>
  );
}
